/**
 * 生成结果相关工具
 * - isSubmittedGeneration: 统一判断是否为提交回执
 * - normalizeGenerationResult: 将任意响应包装为 GenerationResult
 * - extractRequestId: 从回执或原始响应中提取 requestId
 */

import type { GenerationResult, SubmittedGeneration } from '../adapters/types';
import { isRecord, toStringSafe } from './typeGuards';
import { isFormDataLike } from './http';

export const isSubmittedGeneration = (value: unknown): value is SubmittedGeneration => {
  return isRecord(value) && value.submitted === true;
};

export const normalizeGenerationResult = (value: unknown): GenerationResult => {
  if (value === null || value === undefined) {
    return value as GenerationResult;
  }
  if (isFormDataLike(value)) {
    return value;
  }
  if (Array.isArray(value)) {
    return value as GenerationResult;
  }
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return value as GenerationResult;
  }
  if (isRecord(value)) {
    return value as GenerationResult;
  }
  return { data: value } as GenerationResult;
};

export const extractRequestId = (value: unknown): string | undefined => {
  if (!isRecord(value)) {
    return toStringSafe(value);
  }

  const direct = value.requestId ?? value.request_id ?? value.id;
  if (direct !== undefined) {
    const directStr = toStringSafe(direct);
    if (directStr) return directStr;
  }

  const raw = isRecord(value.raw) ? value.raw : undefined;
  if (raw) {
    const nested = raw.requestId ?? raw.request_id ?? raw.id;
    const nestedStr = toStringSafe(nested);
    if (nestedStr) return nestedStr;
  }

  return undefined;
};
